<template>
  <div
    class="c-nav-single-row"
    :class="layoutClasses"
  >
    <template
      v-for="item in navItems"
    >
      <component
        :is="item.contentType"
        :key="item.id"
        v-bind="item.data"
        class="c-nav-single-row__item"
      />
    </template>
  </div>
</template>

<script>
// import NavCard from "@/components/nav/sharedComponents/NavCard.vue";
// import SwatchLink from '../swatch/SwatchLink.vue';
// import LinkCard from '../card/LinkCard.vue';
import ImageCardCta from "../card/ImageCardCta.vue";
export default {
  components: {
    // NavCard,
    // SwatchLink,
    // LinkCard,
    ImageCardCta,
  },
  props: {
    navItems: {
      type: Array,
      default: () => [],
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    layoutClasses() {
      const isMobile = this.isMobile
      let result = []
      if (isMobile) {
        result.push(
          'l-grid',
          'l-grid--2-col',
        )
      } else {
        result.push(
          'l-grid',
          'l-grid--3-col',
        )
      }
      return result
    }
  }
};
</script>

<style lang="scss" scoped>
.c-nav-single-row {
  padding: rem(20px);
  &__item {
    @include respond('tab-land') {
      width: 100%;
      margin-bottom: rem(20px);
    }
  }
}
</style>
